import React from 'react';
import TablaSolicitudDemolicion from './Tablas/TablaSolicitudDemolicion';
import GraficoSolicitudDemolicion from './Graficos/GraficoSolicitudDemolicion';
import { VStack, Heading } from '@chakra-ui/react';
import ObrasDemolicionDashboard from './Dashboard/ObrasDemolicionDashboard';

const ObrasDemolicion: React.FC = () => {
  return (
    <VStack spacing={8} align="stretch">
      <Heading size="lg" textAlign="center" color="blue.700">
        Demolicion
      </Heading>
      <ObrasDemolicionDashboard/>
      <TablaSolicitudDemolicion />
      {/* <GraficoSolicitudDemolicion /> */}
    </VStack>
  );
};

export default ObrasDemolicion;
